export const isArray = (value) => Array.isArray(value);
export const isArrayNotEmpty = (array) => !!(array === null || array === void 0 ? void 0 : array.length);
export const isArrayEmpty = (array) => !(array === null || array === void 0 ? void 0 : array.length);
